/* FSL motion infrastructure.
   Registry inti untuk motion yang KITA tulis sendiri (jalur 2 di PLAN.md),
   terutama section commerce di Fase 5. Halaman FSL hasil konversi memakai
   runtime aslinya, bukan ini.

   Diadaptasi dari aurum-motion.js. Yang diwarisi hanya arsitekturnya:
   pola registry, re-init shopify:section:load, flag reduceMotion dan editor.
   Nilai easing dan durasi TIDAK diwarisi (aturan batas 6b di PLAN.md).

   Dimuat setelah GSAP dan plugin. Bail diam kalau GSAP tidak ada, supaya
   konten tetap tampil (no-break).

   Modul mendaftar lewat: FSL.motion.add(function (scope) { ... })
   scope adalah document saat boot, atau e.target saat section reload. */
(function () {
  var gsap = window.gsap;
  if (!gsap) { return; }

  if (window.ScrollTrigger) { gsap.registerPlugin(window.ScrollTrigger); }
  if (window.SplitText) { gsap.registerPlugin(window.SplitText); }
  if (window.CustomEase) { gsap.registerPlugin(window.CustomEase); }
  /* Sengaja tidak mendaftarkan named ease bawaan Aurum. Kalau nanti kurva
     FSL butuh CustomEase sendiri, daftarkan di sini dengan nilai dari
     token motion FSL, bukan salinan dari theme lain. */

  var ns = window.FSL = window.FSL || {};
  var M = ns.motion = ns.motion || {};
  M.gsap = gsap;
  M.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  M.inEditor = !!(window.Shopify && window.Shopify.designMode);
  M._inits = M._inits || [];
  M._booted = false;

  M.add = function (fn) {
    M._inits.push(fn);
    if (M._booted) {
      try { fn(document); } catch (e) { console.warn('[FSL] init', e); }
    }
  };

  /* Buang ScrollTrigger yang elemen pemicunya sudah tidak ada di dokumen.

     Kenapa perlu: saat Theme Editor memuat ulang sebuah section, markup
     lama dibuang dan diganti yang baru. ScrollTrigger yang menunjuk ke
     elemen lama tetap hidup, memegang referensi ke node yatim, dan ikut
     dihitung setiap refresh. Menumpuk tiap kali setting diubah.

     ScrollTrigger.refresh() saja tidak membersihkannya, hanya menghitung
     ulang posisi. */
  function killOrphanTriggers() {
    if (!window.ScrollTrigger) { return 0; }
    var all = window.ScrollTrigger.getAll();
    var killed = 0;
    for (var i = 0; i < all.length; i++) {
      var t = all[i].trigger;
      if (t && !document.documentElement.contains(t)) {
        all[i].kill();
        killed++;
      }
    }
    return killed;
  }

  M.run = function (scope) {
    var s = scope || document;
    killOrphanTriggers();
    for (var i = 0; i < M._inits.length; i++) {
      try { M._inits[i](s); } catch (e) { console.warn('[FSL] init', e); }
    }
    if (window.ScrollTrigger) { window.ScrollTrigger.refresh(); }
  };

  function boot() {
    M._booted = true;
    M.run(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: re-init hanya di dalam section yang dimuat ulang. */
  document.addEventListener('shopify:section:load', function (e) { M.run(e.target); });

  /* HITUNG ULANG POSISI SETELAH LAYOUT BENAR-BENAR SELESAI.

     ScrollTrigger menghitung titik start dan end saat dibuat. Di boot,
     layout belum final: webfont belum tersaji, gambar belum punya tinggi,
     dan section bertumpuk belum menempati ruang aslinya. Titik-titik itu
     jadi meleset, dan trigger bisa tidak pernah terpicu sama sekali.
     Gejalanya elemen berhenti di state awal gsap.from dan tidak pernah
     tampil, walau semuanya terlihat sehat di console.

     Ini BUKAN menunggu font sebelum menganimasikan (aturan 2 reliability
     melarang itu). Reveal tetap dibangun langsung. Yang dilakukan di sini
     hanya menghitung ulang posisi setelahnya, dan refresh itu idempoten. */
  function refresh() {
    if (window.ScrollTrigger) { window.ScrollTrigger.refresh(); }
  }
  window.addEventListener('load', refresh);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(refresh).catch(function () {});
  }

  console.log('[FSL] motion ready · gsap ' + gsap.version +
              ' · reduceMotion ' + M.reduceMotion + ' · editor ' + M.inEditor);
})();
